import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
import { setAllPermisosUsuario, setCambiarClaveUsuario, setCambiarEstadoUsuario, setCrearUsuario, setEditarUsuario, setListarUsuarios } from '../reducer';
import { useUpdateEffect } from 'primereact/hooks';
import { isEmpty } from 'lodash';
import { ALL_PERMISOS_USUARIOS, CAMBIAR_CLAVE_USUARIO, CAMBIAR_ESTADO_USUARIO, CREAR_USUARIO, EDITAR_USUARIO, findPermission, LISTAR_USUARIOS } from '../../../../utilities/permission';
import { Checkbox } from 'primereact/checkbox';

const UsuarioPermiso = () => {
    const asignaciones = useSelector((state) => state.usuario.asignaciones);
    const emisorSeleccionado = useSelector((state) => state.usuario.emisorSeleccionado);

    //Permisos relacionados con el usuario
    const { allPermisosUsuarios, crearUsuario, listarUsuarios, editarUsuarios, cambiarEstadoUsuario, cambiarClaveUsuario } = useSelector((state) => state.usuario);

    const dispatch = useDispatch();

    const flipFeatures = useCallback(
        (flag) => {
            dispatch(setAllPermisosUsuario(flag));
            dispatch(setListarUsuarios(flag));
            dispatch(setCrearUsuario(flag));
            dispatch(setEditarUsuario(flag));
            dispatch(setCambiarEstadoUsuario(flag));
            dispatch(setCambiarClaveUsuario(flag));
        },
        [dispatch]
    );

    useUpdateEffect(() => {
        if (allPermisosUsuarios) {
            flipFeatures(true);
            return;
        }

        flipFeatures(false);
    }, [allPermisosUsuarios]);

    useEffect(() => {
        if (isEmpty(asignaciones) || isEmpty(emisorSeleccionado)) {
            flipFeatures(false);
            return;
        }

        const asignacion = asignaciones[emisorSeleccionado.ruc];
        if (isEmpty(asignacion?.permisos)) {
            flipFeatures(false);
            return;
        }

        //set everything back to false,
        flipFeatures(false);

        //If all is assigned, then we have nothing else to check
        if (findPermission(ALL_PERMISOS_USUARIOS, asignacion.permisos) > -1) {
            flipFeatures(true);
            return;
        }

        if (findPermission(LISTAR_USUARIOS, asignacion.permisos) > -1) {
            dispatch(setListarUsuarios(true));
        }

        if (findPermission(EDITAR_USUARIO, asignacion.permisos) > -1) {
            dispatch(setEditarUsuario(true));
        }

        if (findPermission(CREAR_USUARIO, asignacion.permisos) > -1) {
            dispatch(setCrearUsuario(true));
        }

        if (findPermission(CAMBIAR_ESTADO_USUARIO, asignacion.permisos) > -1) {
            dispatch(setCambiarEstadoUsuario(true));
        }

        if (findPermission(CAMBIAR_CLAVE_USUARIO, asignacion.permisos) > -1) {
            dispatch(setCambiarClaveUsuario(true));
        }
    }, [asignaciones, emisorSeleccionado, dispatch, flipFeatures]);

    return (
        <div className="flex flex-row justify-content-center  align-items-center gap-3">
            <div className="flex align-items-center">
                <Checkbox
                    inputId="allPermisosUsuario"
                    onChange={(e) => {
                        dispatch(setAllPermisosUsuario(e.target.checked));
                    }}
                    checked={allPermisosUsuarios}
                />
                <label htmlFor="allPermisosUsuario" className="ml-2">
                    Todos
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="listarUsuario"
                    onChange={(e) => {
                        dispatch(setListarUsuarios(e.target.checked));
                    }}
                    checked={listarUsuarios}
                />
                <label htmlFor="listarUsuario" className="ml-2">
                    Listar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="crearUsuario"
                    onChange={(e) => {
                        dispatch(setCrearUsuario(e.target.checked));
                    }}
                    checked={crearUsuario}
                />
                <label htmlFor="crearUsuario" className="ml-2">
                    Crear
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="modificarUsuario"
                    onChange={(e) => {
                        dispatch(setEditarUsuario(e.target.checked));
                    }}
                    checked={editarUsuarios}
                />
                <label htmlFor="modificarUsuario" className="ml-2">
                    Modificar
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="cambiarEstadoUsuario"
                    onChange={(e) => {
                        dispatch(setCambiarEstadoUsuario(e.target.checked));
                    }}
                    checked={cambiarEstadoUsuario}
                />
                <label htmlFor="cambiarEstadoUsuario" className="ml-2">
                    Cambiar estado
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="cambiarClaveUsuario"
                    onChange={(e) => {
                        dispatch(setCambiarClaveUsuario(e.target.checked));
                    }}
                    checked={cambiarClaveUsuario}
                />
                <label htmlFor="cambiarClaveUsuario" className="ml-2">
                    Cambiar clave
                </label>
            </div>
        </div>
    );
};

export default UsuarioPermiso;
